import { Box, Card, CardContent, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { scheduleDays, scheduleEnd, scheduleStart } from '@sophocles/entities/RelaySchedule/relayScheduleUtils';
import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';

function ScheduleDisplay({ schedule, dimmerAvailable = false, asCard = false }) {
  const { t } = useTranslation();

  const user = useSelector(getAuthUserSelector);
  const supportsDayOfWeek = Array.isArray(schedule.days_of_week);
  const days = supportsDayOfWeek ? scheduleDays(schedule.days_of_week, t).join(', ') : '';

  let primaryText = null;
  let secondaryText = null;

  if (schedule.enabled === false) {
    secondaryText = `${schedule.schedule_number}. ${t('sites.inactiveSchedule')}`;
  } else if (schedule.isAlwaysOn) {
    primaryText = `${schedule.schedule_number}. ${t('sites.alwaysOn')}`;
    secondaryText = (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {dimmerAvailable && <span>{dimmingData(schedule, t)}</span>}
      </Box>
    );
  } else if (supportsDayOfWeek) {
    primaryText = (
      <span>
        <b>{schedule.schedule_number}.</b> {days}
      </span>
    );
    secondaryText = (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <span>
          {t('sites.on').toUpperCase()}:{' '}
          {scheduleStart(
            schedule.always_on,
            schedule.on_time,
            schedule.on_type,
            schedule.on_offset,
            null,
            null,
            user,
            t,
          )}
        </span>
        <span>
          {t('sites.off').toUpperCase()}:{' '}
          {scheduleEnd(
            schedule.always_on,
            schedule.off_time,
            schedule.off_type,
            schedule.off_offset,
            null,
            null,
            user,
            t,
          )}
        </span>
        {dimmerAvailable && <span>{dimmingData(schedule, t)}</span>}
      </Box>
    );
  } else {
    secondaryText = (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <span>
          {t('sites.on').toUpperCase()}:{' '}
          {scheduleStart(
            schedule.always_on,
            schedule.on_time,
            schedule.on_type,
            schedule.on_offset,
            null,
            null,
            user,
            t,
          )}
        </span>
        <span>
          {t('sites.off').toUpperCase()}:{' '}
          {scheduleEnd(
            schedule.always_on,
            schedule.off_time,
            schedule.off_type,
            schedule.off_offset,
            null,
            null,
            user,
            t,
          )}
        </span>
        {dimmerAvailable && <span>{dimmingData(schedule, t)}</span>}
      </Box>
    );
  }

  return (
    <>
      {asCard ? (
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle2">{primaryText}</Typography>
            <Typography variant="body2" color="text.secondary">
              {secondaryText}
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Paper variant="outlined" sx={{ mb: 2, p: 1.5 }}>
          <Typography variant="subtitle2">{primaryText}</Typography>
          <Typography variant="body2" color="text.secondary">
            {secondaryText}
          </Typography>
        </Paper>
      )}
    </>
  );
}

export default ScheduleDisplay;
